import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDiKNmb91Nlx51x2sJAvaqDZJcs4iHwoI0",
  authDomain: "acsolutions-53120.firebaseapp.com",
  projectId: "acsolutions-53120",
  storageBucket: "acsolutions-53120.firebasestorage.app",
  messagingSenderId: "606513156569",
  appId: "1:606513156569:web:e88939d9dc10a7a10c89c8",
  measurementId: "G-FX3P4ESCJ7",
};

export const firebaseApp = initializeApp(firebaseConfig);

export const analyticsPromise = isSupported().then((supported) =>
  supported ? getAnalytics(firebaseApp) : null
);
